var _rect, _path, _rect2, _path2, _rect3, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 72,
    fill: "none",
    viewBox: "0 0 202 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59.5,
    height: 70.747,
    x: 0.75,
    y: 0.5,
    fill: "#fff",
    stroke: "#24272F",
    rx: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A7B5",
    strokeWidth: 2,
    d: "M40.195 7.145h13.186M6.844 13.737h21.718M6.844 22.27h41.109M6.844 27.698h32.577M6.844 38.17H44.85M6.844 47.09h21.718M6.844 50.192h21.718M6.844 53.683h21.718M6.844 61.052h42.272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 59.5,
    height: 70.747,
    x: 71.25,
    y: 0.5,
    fill: "#fff",
    stroke: "#7638E1",
    rx: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7638E1",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    d: "M77 10h45M77 14h45M77 18h45M77 22h45M77 26h45M105 32h17M100 36h21.718M100 40h21.718M77.344 61.052h42.272"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 59.5,
    height: 70.747,
    x: 141.75,
    y: 0.5,
    fill: "#fff",
    stroke: "#24272F",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A7B5",
    strokeWidth: 2,
    d: "M181.195 14h13.186M147.844 13.737h21.718M147.844 22.27h41.109M147.844 27.698h32.577M147.844 32h38.006M167.844 47.09h21.718M167.844 50.192h21.718M167.844 53.683h21.718M175 61h15M175 58h15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDocuments);
export default __webpack_public_path__ + "static/media/three-documents.4a7b114e.svg";
export { ForwardRef as ReactComponent };